export default {
  // ナビゲーション
  nav: {
    home: 'ホーム',
    finance: '理財',
    exchange: 'デジタル資産',
    wallet: '資産',
    notice: 'お知らせ',
    invite: '招待',
    withdrawal: '出金'
  },

  // ホーム
  home: {
    title: 'SeekAIpha：AI駆動の新しい富の時代を開く',
    subtitle: '次世代DeFiプロトコル、人工知能とデフレ経済を融合し、持続可能な暗号資産収益エンジンを構築',
    explore: '今すぐ探索',
    watchVideo: '動画を見る',
    
    // コア課題
    coreIssue: '私たちが解決する核心的問題',
    coreIssueDesc: '従来のDeFiは「高収益=高リスク」の死のスパイラルに陥っています。真の価値創造を欠き、持続不可能なポンジスキームです。',
    
    // ソリューション
    solution: 'SeekAIphaのソリューション',
    solutionDesc: '外部利益と内在的デフレを導入し、価値のフライホイールを構築。',
    
    // ソリューションリスト
    solutionList: {
      ai: {
        title: 'AI駆動の価値創造',
        tips: '(機械にあなたのために働かせる)',
        content: '資金の一部はトップレベルのAI取引戦略で管理され、得られた利益は自動的にSKPトークンを買い戻して燃やし、外部市場の利益を生態系に継続的に注入します。'
      },
      deflation: {
        title: '極限デフレの希少資産',
        tips: '(流通すればするほど希少に)',
        content: 'AI利益買い戻し、時価総額維持手数料、初期デフレの3大メカニズムにより、SKP流通量を継続的に削減し、資産価値の堅固な防御壁を構築。'
      },
      stability: {
        title: 'インテリジェントな市場安定',
        tips: '(前例のない下落防止設計)',
        content: '独自の「時価総額維持ウォレット」、市場売却時に105%自動買い戻しをトリガーし、トークン価格に強力なサポートを提供し、ソフトフロア価格のアンカリングを実現。'
      }
    },
    
    // デュアルエンジン
    dualEngine: 'デュアルエンジン、収益倍増効果を点火',
    
    // トークン紹介
    tokens: {
      skp: {
        title: 'SKP (メインエクイティトークン)',
        supply: '総供給量：210万枚 (永久デフレ)',
        desc: 'あなたの生態系パス：流動性マイニング、静的収益、コミュニティガバナンス、紹介報酬に使用。seekAIpha宇宙全体のハードカレンシー。'
      },
      skb: {
        title: 'SKB (名誉報酬トークン)',
        supply: '総供給量：21万枚 (永久デフレ)',
        desc: 'エリートの名誉バッジ：V3以上のコミュニティリーダーにのみ授与。より希少な総供給、より高い価値、アイデンティティと貢献の象徴。'
      }
    },
    
    // エコシステム
    ecosystem: 'エコシステムのリアルタイム脈動',
    ecosystemData: {
      burn: '$SKP 総燃焼量',
      profit: 'AI理財総利益',
      members: 'コミュニティ総メンバー数',
      locked: 'プール総ロック量',
      fund: '時価総額維持基金残高'
    },
    
    // 収益構造
    incomeStructure: '多次元収益構造、初心者からリーダーまでの各段階を満たす',
    stages: {
      static: {
        title: '静的収益 | 安定した基盤',
        items: [
          'V0-V3: 1.5% 日次',
          'V4-V6: 2.1% 日次',
          'V7-V8: 3.0% 日次',
          '収益は生態系成長とAI利益から、純粋なインフレではない'
        ]
      },
      referral: {
        title: '紹介報酬 | ネットワークパワー',
        items: [
          '直接 10% | 間接 5%',
          'ネットワーク効果を迅速に起動'
        ]
      },
      leadership: {
        title: 'コミュニティリーダーシップアワード | グローバル実績',
        items: [
          '地区実績配当を享受、最大80%まで',
          '真の生態系建設者を報酬'
        ]
      },
      honor: {
        title: 'SKB名誉報酬 | 頂点の栄光',
        items: [
          'V3以上のメンバー専用、第二の富のチャネルをアンロック。'
        ]
      }
    },
    
    // FAQ
    faq: {
      title: 'あなたの疑問、私たちが明確に回答',
      q1: {
        question: 'Q: 私のお金は具体的にどこに行きますか？',
        answer: 'A: すべての資金はスマートコントラクトによって厳密に配分されます：20%はAI理財収益、30%はDEXプールに注入して保護、50%は時価総額維持ウォレットに入り価格を安定化。'
      },
      q2: {
        question: 'Q: 市場が暴落した場合、私の資産は安全ですか？',
        answer: 'A: リスクゼロの投資はありません。しかし、私たちの「時価総額維持ウォレット」と「105%買い戻しメカニズム」は下落に対抗するために特別に設計されており、市場の変動時に強力なバッファとサポートを提供します。これは従来のDeFiプロジェクトにはないものです。'
      },
      q3: {
        question: 'Q: どのように始めますか？',
        answer: 'A: 下の「今すぐ参加」ボタンをクリックし、ウォレットを接続すると、100 USDTからseekAIphaの旅を始めることができます。'
      }
    },
    
    // Footer
    footer: {
      cta: '次世代DeFiの初期共同建設者になる準備はできていますか',
      ctaDesc: '数万人の先駆者とともに、AIの未来を操る',
      downloadWhitepaper: 'ホワイトペーパーをダウンロード',
      joinTelegram: '公式Telegramに参加'
    }
  },

  // ウォレット
  wallet: {
    title: 'マイウォレット',
    totalAssets: '総資産推定',
    exchange: '交換',
    withdrawal: '出金',
    myLevel: 'レベル',
    personalPerformance: '個人実績',
    teamPerformance: 'チーム実績',
    districtPerformance: '地区実績',
    areaPerformance: 'エリア実績',
    maxIncome: '最大収益',
    teamNum: 'チームメンバー',
    remainingIncome: '残り収益',
    directNum: '直接紹介',
    myAssets: 'マイアセット',
    assetRecord: '資産記録',
    accumulatedIncome: '累積収益',
    amount: '数量：',
    source: 'ソース：',
    time: '時間：',
    noRecord: '記録なし'
  },

  // 招待
  invite: {
    title: 'SeekAIpha：AI駆動の新しい富の時代を開く',
    subtitle: '次世代DeFiプロトコル、人工知能とデフレ経済を融合し、持続可能な暗号資産収益エンジンを構築',
    myInviteCode: 'マイ招待コード',
    inviteRecord: '招待記録',
    registerTime: '登録時間：',
    performance: '実績',
    noRecord: '記録なし',
    myLevel: 'マイレベル'
  },

  // お知らせ
  notice: {
    title: 'プラットフォームのお知らせ',
    noMore: 'これ以上ありません',
    back: '戻る',
    viewCount: '回閲覧'
  },

  // 交換
  exchange: {
    title: 'スワップ交換',
    balance: '残高：',
    max: 'MAX',
    swapNow: '今すぐ交換',
    enterAmount: '正しい交換金額を入力してください',
    selectCoin: 'コインを選択してください',
    swapFailed: '交換失敗',
    record: '交換記録',
    amount: '数量：',
    time: '時間：',
    noMore: 'これ以上ありません',
    popup: {
      title: '交換',
      subtitle: '入金でSKPをマイニング',
      depositAmount: '入金数量',
      pay: '今すぐ支払う'
    }
  },

  // 理財/入金
  recharge: {
    participate: '入金に参加',
    repurchase: '再購入',
    record: '入金記録',
    selectAmount: '数量を選択',
    depositNow: '今すぐ入金',
    payNow: '今すぐ支払う',
    balance: '残高：',
    insufficientBalance: '残高不足',
    enterAmount: '再購入金額を入力してください',
    minAmount: '再購入金額は以下より小さくできません',
    paySuccess: '支払い成功、ブロック確認待ち',
    historyRecord: '履歴記録',
    status: 'ステータス：',
    pending: '支払い待ち',
    completed: '完了',
    failed: '失敗',
    currentIncome: '現在の収益',
    accumulatedIncome: '累積収益',
    toBeReleased: '解放待ち',
    released: '解放済み'
  },

  // 共通
  common: {
    confirm: '確認',
    cancel: 'キャンセル',
    submit: '送信',
    success: '成功',
    failed: '失敗',
    loading: '読み込み中...',
    noData: 'データなし',
    copySuccess: 'コピーしました',
    copyFailed: 'コピー失敗',
    connectWallet: 'ウォレット接続',
    disconnect: '切断',
    invitationCode: '招待コード',
    enterInvitationCode: '招待コードを入力してください'
  },

  // 出金
  withdrawal: {
    title: '出金',
    withdrawNow: '今すぐ出金',
    withdrawAmount: '出金数量',
    fee: '手数料：',
    record: '出金記録',
    balance: '残高：',
    max: 'MAX',
    withdrawSuccess: '出金成功',
    notEnabled: 'このコインの出金は有効になっていません',
    minAmount: '出金額は以下より小さくできません',
    maxAmount: '出金額は以下より大きくできません',
    exceedBalance: '出金額は残高を超えることはできません',
    noMore: 'これ以上ありません'
  },

  // HTTP
  http: {
    request: 'リクエストエラー',
    repetition: '重複リクエスト',
    timeout: 'タイムアウト',
    err: 'サーバーへの接続に失敗しました！'
  }
}

